import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import {
  Typography,
  Button,
  Grid,
  Box,
  TextField,
  InputAdornment,
  Autocomplete
} from '@mui/material'
import { Navbar } from '../../../component/shared/Navbar'
import { PageContainer } from '../../../component/styled/PageContainer'
import AddIcon from '@mui/icons-material/Add'
import SearchIcon from '@mui/icons-material/Search'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import IncentiveTable from './IncentiveTable'
import Breadcrumb from '../../../component/shared/Breadcrumb'
import { getRecentMonths } from '../../../utils/date'
import { useExportSalesIncentives } from '../../../api/sales-commission-incentive'
import { ExportButton } from '../../../component/shared/component/ExportButton'

export const SalesIncentivePage = () => {
  const monthOptions = getRecentMonths(24)
  const [search, setSearch] = useState('')
  const [monthYear, setMonthYear] = useState(monthOptions[0].value)
  const [openDialog, setOpenDialog] = useState(false)
  const [openImport, setOpenImport] = useState(false)
  const [editData, setEditData] = useState(null)
  const { mutateAsync: exportIncentives } = useExportSalesIncentives()

  const handleAdd = () => {
    setEditData(null)
    setOpenDialog(true)
  }

  const handleEdit = (data) => {
    setEditData(data)
    setOpenDialog(true)
  }

  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Sales Incentive</title>
      </Helmet>
      <Navbar />
      <PageContainer>
        <Grid container spacing={2} paddingTop={5}>
          <Grid item xs={12}>
            <Breadcrumb items={[{ label: 'Incentive' }]} />
            <Typography variant='h1'>Incentive</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display='flex'
            justifyContent='space-between'
            alignItems='center'
            gap={2}
          >
            <Box display='flex' gap={2} flex={1}>
              <TextField
                variant='outlined'
                size='small'
                placeholder='Search incentives...'
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
                sx={{ width: 300 }}
              />
              <Autocomplete
                size='small'
                options={monthOptions}
                value={monthOptions.find((option) => option.value === monthYear)}
                onChange={(_, { value }) => value && setMonthYear(value)}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => (
                  <TextField {...params} variant='outlined' placeholder='Select Month' />
                )}
                sx={{ width: 250 }}
                disableClearable={true}
              />
            </Box>
            <Box display='flex' gap={2}>
              <Button
                variant='outlined'
                startIcon={<FileUploadIcon />}
                onClick={() => setOpenImport(true)}
              >
                IMPORT
              </Button>
              <Button
                variant='contained'
                color='primary'
                startIcon={<AddIcon />}
                onClick={handleAdd}
              >
                ADD INCENTIVE
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
            <ExportButton
              exportFn={() => exportIncentives({ monthYear })}
              filename={`Sales_Incentives_${monthYear}.xlsx`}
            />
          </Grid>
          <Grid item xs={12}>
            <IncentiveTable
              search={search}
              monthYear={monthYear}
              onEdit={handleEdit}
              openDialog={openDialog}
              setOpenDialog={setOpenDialog}
              editData={editData}
              openImport={openImport}
              setOpenImport={setOpenImport}
            />
          </Grid>
        </Grid>
      </PageContainer>
    </>
  )
}
